<template>
  <div>
    <section class="">
      <div class="container">
        <ul class="btn-box">
          <li>
            <router-link :to="{ name: 'MemberInfo' }" tag="button">
              <img src="img/member-icon-1.svg" alt="" />
              {{ $t("會員資料") }}
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: 'OrderList' }"
              tag="button"
              class="active"
            >
              <img src="img/member-icon-2.svg" alt="" />
              {{ $t("我的套票") }}
            </router-link>
          </li>
          <li v-if="local != 'jp'">
            <router-link :to="{ name: 'CardInfo' }" tag="button">
              <img src="img/member-icon-6.svg" alt="" />
              {{ $t("卡片資料") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'Coupon' }" tag="button">
              <img src="img/member-icon-8.svg" alt="" />
              {{ $t("套票兌換") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'TradeRecord' }" tag="button">
              <img src="img/member-icon-4.svg" alt="" />
              {{ $t("卡片交易紀錄") }}
            </router-link>
          </li>
          <li v-if="local != 'jp'">
            <router-link :to="{ name: 'CarbonReduction' }" tag="button">
              <img src="img/member-icon-9.png" alt="" />
              {{ $t("減碳計算") }}
            </router-link>
          </li>
          <li v-if="local != 'jp'">
            <router-link :to="{ name: 'MemberCoupon' }" tag="button">
              <img src="img/member-icon-2.svg" alt="" />
              {{ $t("優惠專區") }}
            </router-link>
          </li>
          <li v-if="local != 'jp' && hasInvite">
            <router-link :to="{ name: 'InvitEvent' }" tag="button">
              <img src="img/member_icon_friends.svg" alt="" />
              {{ $t("邀請朋友") }}
            </router-link>
          </li>
          <li v-if="local != 'jp' && hasCREvent">
            <router-link :to="{ name: 'CREventCoupon' }" tag="button">
              <img src="img/cr_icon.svg" alt="" />
              {{ $t("減碳活動") }}
            </router-link>
          </li>
        </ul>
        <div
          class="main"
          v-if="
            OrderData.Order != null &&
            (OrderData.Order.Status == 1 || OrderData.Order.Status == 99)
          "
        >
          <div class="bg-box">
            <h1>{{ $t("訂單詳情") }}</h1>
          </div>
          <div class="bg-box" v-if="OrderData.Order.ProductType == 1">
            <ul class="text-box">
              <li class="title">
                <div>{{ $t("訂單編號") }}</div>
                <div>{{ OrderData.Order.OrderId }}</div>
              </li>
              <hr />
              <li class="single-item">
                <ul
                  class=""
                  v-for="Ticket in OrderData.Order.Tickets"
                  :key="Ticket.TId"
                >
                  <li>
                    <div class="qr-box">
                      <img src="img/qrcode-pic.svg" alt="" />
                      <p
                        v-if="
                          !Ticket.IsUsing &&
                          !Ticket.IsExpired &&
                          !Ticket.IsRefunded &&
                          Ticket.DonateStatus == 0
                        "
                      >
                        {{ $t("尚未啟用") }}
                      </p>
                      <p
                        v-if="
                          !Ticket.IsUsing &&
                          !Ticket.IsExpired &&
                          !Ticket.IsRefunded &&
                          Ticket.DonateStatus == 1
                        "
                      >
                        {{ $t("轉贈中") }}
                      </p>
                      <p v-if="Ticket.DonateStatus == 2">
                        {{ $t("已轉贈") }}
                      </p>
                      <p v-if="Ticket.IsExpired && Ticket.DonateStatus == 0">
                        {{ $t("已過期") }}
                      </p>
                      <p v-if="Ticket.IsRefunded && Ticket.DonateStatus == 0">
                        {{ $t("已退款") }}
                      </p>
                    </div>
                  </li>
                  <!-- 0620 新增 轉贈啟用按鈕 -->

                  <li class="btn-box">
                    <button
                      v-if="
                        !Ticket.IsUsing &&
                        !Ticket.IsExpired &&
                        !Ticket.IsRefunded &&
                        Ticket.DonateStatus == 1
                      "
                      @click="ticketDonateCancel(Ticket.TId)"
                    >
                      {{ $t("取消轉贈") }}
                    </button>
                    <button
                      v-if="
                        !Ticket.IsUsing &&
                        !Ticket.IsExpired &&
                        !Ticket.IsRefunded &&
                        Ticket.DonateStatus == 0 &&
                        OrderData.Order.TotalAmount > 0
                      "
                      @click="ticketDonate(Ticket.TId)"
                    >
                      {{ $t("轉贈") }}
                    </button>
                    <button
                      v-if="
                        (OrderData.Ticket == null ||
                          OrderData.CanActiveNewTicket) &&
                        !Ticket.IsUsing &&
                        !Ticket.IsExpired &&
                        !Ticket.IsRefunded &&
                        Ticket.DonateStatus == 0
                      "
                      @click="ticketActive(Ticket.TId)"
                    >
                      {{ $t("立即啟用") }}
                    </button>
                  </li>
                  <!-- 0620 新增 -->
                  <hr />
                  <li>
                    <div>{{ $t("商品名稱") }}</div>
                    <div>{{ OrderData.Order.Product.Name }}</div>
                  </li>
                  <li>
                    <div>{{ $t("類型") }}</div>
                    <div class="circle-border">{{ $t("時數票(QR Code)") }}</div>
                  </li>
                  <li>
                    <div>{{ $t("品項") }}</div>
                    <div class="circle-border">
                      {{ OrderData.Order.Product.Time }}{{ $t("小時") }}
                    </div>
                  </li>
                  <hr />
                  <li>
                    <div>{{ $t("結束時間") }}</div>
                    <div
                      class="time"
                      v-if="
                        Ticket.IsUsing &&
                        !Ticket.IsExpired &&
                        Ticket.DonateStatus == 0
                      "
                    >
                      {{ timeString(Ticket.ExpireTime, "YYYY/MM/DD HH:mm") }}
                    </div>
                    <div
                      class="time"
                      v-if="
                        Ticket.IsUsing &&
                        Ticket.IsExpired &&
                        Ticket.DonateStatus == 0
                      "
                    >
                      {{ timeString(Ticket.ExpireTime, "YYYY/MM/DD HH:mm") }}
                      ({{ $t("已過期, 僅可出站") }})
                    </div>
                    <div
                      class="time"
                      v-if="
                        !Ticket.IsUsing &&
                        Ticket.IsExpired &&
                        Ticket.DonateStatus == 0
                      "
                    >
                      {{ timeString(Ticket.ExpireTime, "YYYY/MM/DD HH:mm") }}
                      ({{ $t("已過期") }})
                    </div>
                    <div
                      class="time"
                      v-if="
                        !Ticket.IsUsing &&
                        !Ticket.IsExpired &&
                        !Ticket.IsRefunded &&
                        Ticket.DonateStatus == 0
                      "
                    >
                      {{ $t("尚未啟用") }}
                    </div>
                    <div
                      class="time"
                      v-if="
                        !Ticket.IsUsing &&
                        !Ticket.IsExpired &&
                        !Ticket.IsRefunded &&
                        Ticket.DonateStatus == 1
                      "
                    >
                      {{ $t("轉贈中") }}
                    </div>
                    <div class="color-g" v-if="Ticket.DonateStatus == 2">
                      {{ $t("已轉贈") }}
                    </div>
                    <div
                      class="color-g"
                      v-if="Ticket.IsRefunded && Ticket.DonateStatus == 0"
                    >
                      {{ $t("已退款") }}
                    </div>
                  </li>
                  <li
                    v-if="
                      (Ticket.IsUsing || Ticket.IsExpired) &&
                      Ticket.DonateStatus == 0
                    "
                  >
                    <div>YouBike ({{ $t("點選序號進行複製") }})</div>
                    <div
                      @click="
                        copyYouBike(
                          Ticket.voucher_uuid + '|' + Ticket.voucher_url
                        )
                      "
                    >
                      {{ Ticket.voucher_uuid }}
                    </div>
                  </li>
                  <li
                    v-if="
                      (Ticket.IsUsing || Ticket.IsExpired) &&
                      Ticket.DonateStatus == 0
                    "
                  >
                    <div>QR No.</div>
                    <div class="box">
                      {{ Ticket.CardId }}
                      <router-link
                        :to="{ name: 'TicketLog', params: { TId: Ticket.TId } }"
                        tag="button"
                      >
                        {{ $t("搭乘紀錄") }}
                      </router-link>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <div class="bg-box" v-if="OrderData.Order.ProductType == 2">
            <ul class="text-box">
              <!-- 0610 訂單編號 -->
              <li class="title">
                <div>{{ $t("訂單編號") }}</div>
                <div>{{ OrderData.Order.OrderId }}</div>
              </li>
              <hr
                v-if="OrderData.Order.o_maas_pt_det.o_maas_pt_code_type == 2"
              />
              <li
                class="single-item"
                v-if="OrderData.Order.o_maas_pt_det.o_maas_pt_code_type == 2"
              >
                <div class="qr-box">
                  <img src="img/qrcode-pic.svg" alt="" />
                  <p v-if="OrderData.Order.Status == 1">
                    {{ $t("已付款") }}
                  </p>
                  <p v-if="OrderData.Order.Status == 99">
                    {{ $t("已退款") }}
                  </p>
                </div>
              </li>
              <hr />
              <li>
                <div>{{ $t("商品名稱") }}</div>
                <div>
                  {{ OrderData.Order.o_maas_pt_det.o_maas_pt_name_zh_tw }}
                </div>
              </li>
              <li>
                <div>{{ $t("類型") }}</div>
                <div class="circle-border">{{ $t("天數票") }}</div>
              </li>
              <li>
                <div>{{ $t("品項") }}</div>
                <div class="circle-border">
                  {{ OrderData.Order.o_maas_pt_det.o_maas_pt_expire
                  }}{{ $t("天") }}
                </div>
              </li>
              <hr />
              <li>
                <div>{{ $t("使用效期") }}</div>
                <div>
                  {{
                    timeString(
                      OrderData.Order.o_maas_so_mstr.o_maas_so_start,
                      "YYYY/MM/DD"
                    )
                  }}
                  ~
                  {{
                    timeString(
                      OrderData.Order.o_maas_so_mstr.o_maas_so_expire,
                      "YYYY/MM/DD"
                    )
                  }}
                </div>
              </li>
              <li
                v-if="
                  OrderData.Order.o_maas_so_mstr.voucher_uuid &&
                  OrderData.Order.Status != 99 &&
                  !OrderData.Order.o_maas_so_mstr.o_maas_so_rf_ing
                "
              >
                <div>YouBike ({{ $t("點選序號進行複製") }})</div>
                <div
                  @click="
                    copyYouBike(
                      OrderData.Order.o_maas_so_mstr.voucher_uuid +
                        '|' +
                        OrderData.Order.o_maas_so_mstr.voucher_url
                    )
                  "
                >
                  {{ OrderData.Order.o_maas_so_mstr.voucher_uuid }}
                </div>
              </li>
              <li v-if="OrderData.Order.o_maas_so_mstr.CardId">
                <div>QR No.</div>
                <div class="box">
                  {{ OrderData.Order.o_maas_so_mstr.CardId }}
                  <router-link
                    :to="{
                      name: 'MTicketLog',
                      params: {
                        o_maas_so_seq:
                          OrderData.Order.o_maas_so_mstr.o_maas_so_seq,
                      },
                    }"
                    tag="button"
                  >
                    {{ $t("搭乘紀錄") }}
                  </router-link>
                </div>
              </li>
            </ul>
          </div>
          <hr />
          <div class="bg-box">
            <h1>{{ $t("付款資訊") }}</h1>
            <hr />
            <ul class="text-box">
              <li>
                <div>{{ $t("購買日期") }}</div>
                <div>
                  {{
                    timeString(
                      OrderData.Order.CreateTime,
                      "YYYY/MM/DD HH:mm:ss"
                    )
                  }}
                </div>
              </li>
              <li>
                <div>{{ $t("價格") }}</div>
                <div>NTD {{ OrderData.Order.TotalAmount }}</div>
              </li>
              <li>
                <div>{{ $t("支付方式") }}</div>
                <div v-if="OrderData.Order.PayType == -1">
                  {{ $t("舊訂單") }}
                </div>
                <div v-if="OrderData.Order.PayType == 0">
                  {{ $t("信用卡") }}
                </div>
                <div v-if="OrderData.Order.PayType == 1">LINE PAY</div>
                <div v-if="OrderData.Order.PayType == 2">
                  {{ $t("商品卷") }}({{ OrderData.Order.CouponCode }})
                </div>
                <div v-if="OrderData.Order.PayType == 3">
                  {{ $t("iPASS MONEY") }}
                </div>
              </li>
              <hr />
              <li v-if="OrderData.Order.ProductType == 1">
                <div>{{ $t("張數") }}</div>
                <div>{{ OrderData.Order.Count }} {{ $t("張") }}</div>
              </li>
              <li v-if="OrderData.Order.ProductType == 2">
                <div>{{ $t("優惠券抵用") }}</div>
                <div>NTD 0</div>
              </li>
              <li v-if="OrderData.Order.ProductType == 2">
                <div>{{ $t("企業會員優惠") }}</div>
                <div>NTD 0</div>
              </li>
              <li>
                <div>{{ $t("支付金額") }}</div>
                <div class="total">NTD {{ OrderData.Order.TotalAmount }}</div>
              </li>
              <hr v-if="false" />
              <li v-if="false">
                <div>{{ $t("贈與點數") }}</div>
                <div>
                  {{ OrderData.Order.o_maas_so_mstr.o_maas_so_ret_bonus }}
                </div>
              </li>
              <li v-if="false">
                <div>{{ $t("剩餘點數") }}</div>
                <div class="box">
                  {{
                    OrderData.Order.o_maas_so_mstr.o_maas_so_ret_bonus -
                    OrderData.Order.o_maas_so_mstr.o_maas_so_used_bonus
                  }}
                  <router-link
                    :to="{
                      name: 'PointOrderList',
                      params: {
                        o_maas_so_nbr:
                          OrderData.Order.o_maas_so_mstr.o_maas_so_nbr,
                      },
                    }"
                    tag="button"
                  >
                    {{ $t("使用記錄") }}
                  </router-link>
                </div>
              </li>
              <hr
                v-if="
                  OrderData.Order.Status != 99 &&
                  OrderData.Order.TotalAmount > 0
                "
              />
              <li
                v-if="
                  OrderData.Order.Status != 99 &&
                  OrderData.Order.TotalAmount > 0
                "
              >
                <div>{{ $t("購票證明") }}</div>
                <div class="box">
                  <button @click="proveApplication()">{{ $t("下載") }}</button>
                </div>
              </li>
              <!-- 0622 新增 li.btn-box -->
              <li
                class="refund-btn btn-box"
                v-if="
                  OrderData.Order.ProductType == 1 &&
                  OrderData.Order.Status != 99 &&
                  OrderData.Order.TotalAmount > 0 &&
                  OrderData.CanRefund
                "
              >
                <button type="button" class="btn" @click="refundApplication()">
                  {{ $t("申請退款") }}
                </button>
              </li>
              <li
                class="refund-btn btn-box"
                v-if="
                  OrderData.Order.ProductType == 2 &&
                  OrderData.Order.Status != 99 &&
                  OrderData.Order.TotalAmount > 0 &&
                  !OrderData.Order.o_maas_so_mstr.o_maas_so_rf_ing &&
                  OrderData.CanRefund
                "
              >
                <button type="button" class="btn" @click="refundMApplication()">
                  {{ $t("申請退款") }}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import VueI18n from "vue-i18n";
import AES from "@/utils/aes.js";
import VueClipboard from "vue-clipboard2";
import Storage from "@/utils/storage.js";

Vue.use(VueAxios, axios);
Vue.use(VueI18n);
Vue.use(VueClipboard);

// this.$t("立即購買")
const messages = {
    zh_tw: {
    "會員資料": "會員資料",
    "我的套票": "我的套票",
    "卡片資料": "卡片資料",
    "套票兌換": "套票兌換",
    "卡片交易記錄": "卡片交易記錄",
    "其他資訊": "其他資訊",
    "訂單詳情": "訂單詳情",
    "訂單編號": "訂單編號",
    "尚未啟用": "尚未啟用",
    "轉贈中": "轉贈中",
    "已轉贈": "已轉贈",
    "已過期": "已過期",
    "已退款": "已退款",
    "取消轉贈": "取消轉贈",
    "轉贈": "轉贈",
    "立即啟用": "立即啟用",
    "商品名稱": "商品名稱",
    "類型": "類型",
    "時數票(QR Code)": "時數票(QR Code)",
    "品項": "品項",
    "小時": "小時",
    "結束時間": "結束時間",
    "已過期, 僅可出站": "已過期, 僅可出站",
    "點選序號進行複製": "點選序號進行複製",
    "搭乘紀錄": "搭乘紀錄",
    "天數票": "天數票",
    "天": "天",
    "使用效期": "使用效期",
    "付款資訊": "付款資訊",
    "購買日期": "購買日期",
    "價格": "價格",
    "支付方式": "支付方式",
    "信用卡": "信用卡",
    "商品卷": "商品卷",
    "張數": "張數",
    "張": "張",
    "優惠券抵用": "優惠券抵用",
    "企業會員優惠": "企業會員優惠",
    "支付金額": "支付金額",
    "贈與點數": "贈與點數",
    "剩餘點數": "剩餘點數",
    "使用記錄": "使用記錄",
    "購票證明": "購票證明",
    "下載": "下載",
    "申請退款": "申請退款",
    "錯誤": "錯誤",
    "取得訂單過程發生錯誤, 請稍後再試一次": "取得訂單過程發生錯誤, 請稍後再試一次",
    "確定": "確定",
    "請再次確認": "請再次確認",
    "您即將啟用「": "您即將啟用「",
    "」，套票一經啟用便無法退款也無法轉贈，請問是否確定啟用？": "」，套票一經啟用便無法退款也無法轉贈，請問是否確定啟用？",
    "取消": "取消",
    "請稍候...": "請稍候...",
    "啟用票卡過程發生錯誤, 請稍後再試一次": "啟用票卡過程發生錯誤, 請稍後再試一次",
    "啟用成功": "啟用成功",
    "請輸入受贈者手機號碼": "請輸入受贈者手機號碼",
    "請輸入包含國碼之手機號碼": "請輸入包含國碼之手機號碼",
    "轉贈票卡過程發生錯誤, 請稍後再試一次": "轉贈票卡過程發生錯誤, 請稍後再試一次",
    "轉贈成功": "轉贈成功",
    "轉贈碼已透過簡訊傳送至您的手機, 請在24小時內告知受贈者進行驗證, 即可完成轉贈流程": "轉贈碼已透過簡訊傳送至您的手機, 請在24小時內告知受贈者進行驗證, 即可完成轉贈流程",
    "取消轉贈票卡過程發生錯誤, 請稍後再試一次": "取消轉贈票卡過程發生錯誤, 請稍後再試一次",
    "取消轉贈成功": "取消轉贈成功",
    "已取消轉贈": "已取消轉贈",
    "複製成功": "複製成功",
    "是否立刻前往兌換說明頁面進行兌換?": "是否立刻前往兌換說明頁面進行兌換?",
    "是": "是",
    "否": "否",
    "序號複製失敗, 請稍後再試一次": "序號複製失敗, 請稍後再試一次",
    "請輸入要退款的票卡數量": "請輸入要退款的票卡數量",
    "此訂單最多可退款票卡數量為: ": "此訂單最多可退款票卡數量為: ",
    "申請退款的票卡數量不可小於1張": "申請退款的票卡數量不可小於1張",
    "申請退款的票卡數量不可大於": "申請退款的票卡數量不可大於",
    "申請退款過程發生錯誤, 請稍後再試一次": "申請退款過程發生錯誤, 請稍後再試一次",
    "退款申請成功": "退款申請成功",
    "您的退款申請已成功送出": "您的退款申請已成功送出",
    "退款": "退款",
    "申請退款後將無法繼續使用此票卡, 是否確定進行退款?": "申請退款後將無法繼續使用此票卡, 是否確定進行退款?",
    "卡片交易紀錄": "卡片交易紀錄",
    "減碳計算": "減碳計算",
  },
  en: {
    "會員資料": "Member info",
    "我的套票": "My pass",
    "卡片資料": "Card info",
    "套票兌換": "Redeem pass",
    "卡片交易記錄": "Card record",
    "其他資訊": "Other info",
    "訂單詳情": "Order details",
    "訂單編號": "Order number",
    "尚未啟用": "Yet to be enabled",
    "轉贈中": "Transferring ",
    "已轉贈": "Transferred",
    "已過期": "Expired",
    "已退款": "Refunded",
    "取消轉贈": "Transfer canceled",
    "轉贈": "Transfer",
    "立即啟用": "Enable",
    "商品名稱": "Name",
    "類型": "Type",
    "時數票(QR Code)": "Hour pass (QR Code)",
    "品項": "Item",
    "小時": "Hour",
    "結束時間": "End time",
    "已過期, 僅可出站": "Expired and for exit only",
    "點選序號進行複製": "Click the number to copy",
    "搭乘紀錄": "Transportation record",
    "天數票": "Monthly/Weekly pass",
    "天": "Day",
    "使用效期": "Validity",
    "付款資訊": "Payment info",
    "購買日期": "Date of purchase",
    "價格": "Price",
    "支付方式": "Payment",
    "信用卡": "Credit card",
    "商品卷": "Coupon",
    "張數": "Amount of coupon",
    "張": "Quantity",
    "優惠券抵用": "Use coupon",
    "企業會員優惠": "Discounts for enterprise members",
    "支付金額": "Total",
    "贈與點數": "Given points",
    "剩餘點數": "Remaining points",
    "使用記錄": "Use record",
    "購票證明": "Proof of purchase",
    "下載": "Download",
    "申請退款": "Apply for refund",
    "錯誤": "Error",
    "取得訂單過程發生錯誤, 請稍後再試一次": "Error. Please try again.",
    "確定": "Confirm",
    "請再次確認": "Please confirm again",
    "您即將啟用「": "You're going to enable [",
    "」，套票一經啟用便無法退款也無法轉贈，請問是否確定啟用？": "]. Once the pass is enabled, it cannot be refunded or transferred. Do you want to enable it?",
    "取消": "Cancel",
    "請稍候...": "Wait a second",
    "啟用票卡過程發生錯誤, 請稍後再試一次": "Error. Please try again.",
    "啟用成功": "Enabled",
    "請輸入受贈者手機號碼": "Please enter the mobile number of the recipient.",
    "請輸入包含國碼之手機號碼": "Please enter your mobile number including country code.",
    "轉贈票卡過程發生錯誤, 請稍後再試一次": "Error. Please try again.",
    "轉贈成功": "Transferred",
    "轉贈碼已透過簡訊傳送至您的手機, 請在24小時內告知受贈者進行驗證, 即可完成轉贈流程": "The transfer code has been sent to your mobile. Please inform the recipient to verify within 24 hours to complete the transfer.",
    "取消轉贈票卡過程發生錯誤, 請稍後再試一次": "Error. Please try again.",
    "取消轉贈成功": "Transfer canceled successfully",
    "已取消轉贈": "Transfer canceled ",
    "複製成功": "Copied",
    "是否立刻前往兌換說明頁面進行兌換?": "Do you want to go to the redemption instructions page?",
    "是": "Yes",
    "否": "No",
    "序號複製失敗, 請稍後再試一次": "Failed to copy the number. Please try again.",
    "請輸入要退款的票卡數量": "Please enter the amount of passes to be refunded.",
    "此訂單最多可退款票卡數量為: ": "The maximum amount of refundable passes for this order is:",
    "申請退款的票卡數量不可小於1張": "The amount of passes for refund should not be less than 1.",
    "申請退款的票卡數量不可大於": "The amount of passes applied for refund cannot exceed",
    "申請退款過程發生錯誤, 請稍後再試一次": "Error. Please try again.",
    "退款申請成功": "Refund application done.",
    "您的退款申請已成功送出": "Your refund application has been sent.",
    "退款": "Refund",
    "申請退款後將無法繼續使用此票卡, 是否確定進行退款?": "After applying for refund, you will not be able to continue to use this pass. Are you sure to refund?",
    "卡片交易紀錄": "Activity",
    "減碳計算": "Carbon Reduced",
  },
  jp: {
    "會員資料": "マイページ",
    "我的套票": "購入/予約履歴",
    "卡片資料": "卡片資料",
    "套票兌換": "チケット引き換え",
    "卡片交易記錄": "カード取引履歴",
    "其他資訊": "その他の情報",
    "訂單詳情": "注文詳細",
    "訂單編號": "注文番号",
    "尚未啟用": "未使用",
    "轉贈中": "転送中",
    "已轉贈": "転送済みです",
    "已過期": "有効期限切れ",
    "已退款": "既に返金されています",
    "取消轉贈": "転送を取り消しました",
    "轉贈": "転送",
    "立即啟用": "今すぐ使用する",
    "商品名稱": "商品名",
    "類型": "タイプ",
    "時數票(QR Code)": "フリーパス(QRコード)",
    "品項": "種類",
    "小時": "時間",
    "結束時間": "終了時間",
    "已過期, 僅可出站": "期限切れ,退場のみ可能です",
    "點選序號進行複製": "コピーするクーポン番号をクリックします",
    "搭乘紀錄": "利用履歴",
    "天數票": "天數票",
    "天": "天",
    "使用效期": "有効期間",
    "付款資訊": "お支払い情報",
    "購買日期": "購入日",
    "價格": "価格",
    "支付方式": "支払い方法",
    "信用卡": "クレジットカード",
    "商品卷": "フリーパス",
    "張數": "枚数",
    "張": "枚",
    "優惠券抵用": "クーポンを使用する",
    "企業會員優惠": "企業会員特典",
    "支付金額": "お支払金額",
    "贈與點數": "贈與點數",
    "剩餘點數": "剩餘點數",
    "使用記錄": "利用履歴",
    "購票證明": "購入証明",
    "下載": "ダウンロード",
    "申請退款": "払い戻し申請をする",
    "錯誤": "エラー",
    "取得訂單過程發生錯誤, 請稍後再試一次": "購入手続き中にエラーが発生しました,時間をおいてから再度お試しください",
    "確定": "確定",
    "請再次確認": "再度ご確認ください",
    "您即將啟用「": "「",
    "」，套票一經啟用便無法退款也無法轉贈，請問是否確定啟用？": "」が有効になると、チケットの払い戻しや転送はできません。本当に使用しますか？",
    "取消": "取消",
    "請稍候...": "しばらくお待ちください",
    "啟用票卡過程發生錯誤, 請稍後再試一次": "チケットの「今すぐ使用」中にエラーが発生しました,時間をおいてから再度お試しください",
    "啟用成功": "今すぐ使用できます",
    "請輸入受贈者手機號碼": "受取人の電話番号を入力してください",
    "請輸入包含國碼之手機號碼": "国番号を含む電話番号を入力してください",
    "轉贈票卡過程發生錯誤, 請稍後再試一次": "チケットの転送中にエラーが発生しました,時間をおいてから再度お試しください",
    "轉贈成功": "転送に成功しました",
    "轉贈碼已透過簡訊傳送至您的手機, 請在24小時內告知受贈者進行驗證, 即可完成轉贈流程": "転送コードはSMSで携帯電話に送信されました,24時間以内に手続きを進めるように受信者に通知すると転送は完了になります",
    "取消轉贈票卡過程發生錯誤, 請稍後再試一次": "チケットの転送中にエラーが発生しました,時間をおいてから再度お試しください",
    "取消轉贈成功": "転送の取り消しに成功しました",
    "已取消轉贈": "転送をすでに取り消しました",
    "複製成功": "コピー成功",
    "是否立刻前往兌換說明頁面進行兌換?": "引き換えページに移動してすぐに引き換えますか？",
    "是": "はい",
    "否": "いいえ",
    "序號複製失敗, 請稍後再試一次": "クーポン番号のコピーに失敗しました,時間をおいてから再度お試しください",
    "請輸入要退款的票卡數量": "払い戻すチケットの枚数を入力してください",
    "此訂單最多可退款票卡數量為: ": "この注文で払い戻しできるチケットの枚数は次の通りです：",
    "申請退款的票卡數量不可小於1張": "払い戻しできるチケット申請枚数は１枚以上です",
    "申請退款的票卡數量不可大於": "払い戻しを申請できるチケットの枚数は以下のとおりです",
    "申請退款過程發生錯誤, 請稍後再試一次": "払い戻しの申請中にエラーが発生しました,時間をおいてから再度お試しください",
    "退款申請成功": "払い戻し申請に成功しました",
    "您的退款申請已成功送出": "払い戻し申請の送信に成功しました",
    "退款": "払い戻し",
    "申請退款後將無法繼續使用此票卡, 是否確定進行退款?": "払い戻しを申請すると,このチケットは使用できなくなります,払い戻ししてもよろしいですか？",
    "卡片交易紀錄": "カード取引履歴",
    "減碳計算": "減碳計算",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "OrderInfo",
  i18n,
  data() {
    return {
      OrderData: {},
      isMobile:
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        ) != null,
      local: "zh_tw",
      IsTester: false,
      hasInvite: false,
      hasCREvent: false,
    };
  },
  created: function () {
    let that = this;
    $.ajax({
      url: that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/OrderInfo",
      //url: "https://localhost:44321/Html/OrderInfo",
      type: "post",
      data: {
        OrderId: that.$route.params.OrderId,
        token: Storage.get("ek_login_token"),
      },
      dataType: "json",
      error: function () {
        that.$swal({
          heightAuto: false,
          title: that.$t("錯誤"),
          text: that.$t("取得訂單過程發生錯誤, 請稍後再試一次"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: that.$t("確定"),
        });
      },
      success: function (res) {
        // 判斷結果
        if (res.ok) {
          that.OrderData = JSON.parse(res.data);
          that.IsTester = that.OrderData.IsTester;
          that.hasInvite = response.OrderData.hasInvite;
          that.hasCREvent = response.OrderData.hasCREvent;
        } else if (res.error_msg) {
          var error_msg = JSON.parse(res.error_msg);
          if (res.toekn_error) {
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              willClose: function () {
                // 移除登入資訊
                Storage.remove("ek_login_token");
                // 回到首頁
                that.$router.push({
                  name: "Home",
                  params: {},
                });
              },
            });
          } else {
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          }
        }
      },
    });
  },
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("member");
    $(".wrapper").addClass("member-order-main");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
    this.local = i18n.locale;
  },
  updated: function () {
    if ($(".single-item")) {
      $(".single-item").slick({});
    }
  },
  methods: {
    timeAdd(time, hours) {
      return moment(time).add(hours, "hours");
    },
    timeString(time, format) {
      return moment(time).format(format || "YYYY-MM-DD, HH:mm:ss");
    },
    ticketActive(TId) {
      let that = this;
      that
        .$swal({
          heightAuto: false,
          icon: "warning",
          title: that.$t("請再次確認"),
          text:
            that.$t("您即將啟用「") +
            that.OrderData.Order.Product.Name +
            that.$t("」，套票一經啟用便無法退款也無法轉贈，請問是否確定啟用？"),
          showCancelButton: true,
          confirmButtonText: that.$t("確定"),
          cancelButtonText: that.$t("取消"),
        })
        .then((result) => {
          if (result.isConfirmed) {
            // 顯示請稍候
            that.$swal({
              heightAuto: false,
              title: that.$t("請稍候..."),
              allowOutsideClick: false,
              showConfirmButton: false,
              willOpen: function () {
                that.$swal.showLoading();
              },
            });
            $.ajax({
              url:
                that.GLOBAL.apiSrc +
                that.GLOBAL.subDirectory +
                "/Htmlv2/TicketActive",
              //url: "https://localhost:44321/Html/TicketActive",
              type: "post",
              data: {
                TId: TId,
                token: Storage.get("ek_login_token"),
              },
              dataType: "json",
              error: function () {
                that.$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  text: that.$t("啟用票卡過程發生錯誤, 請稍後再試一次"),
                  icon: "error",
                  allowOutsideClick: false,
                  confirmButtonText: that.$t("確定"),
                });
              },
              success: function (res) {
                // 判斷結果
                if (res.ok) {
                  that.$swal({
                    heightAuto: false,
                    icon: "success",
                    title: that.$t("啟用成功"),
                    showConfirmButton: false,
                    timer: 1500,
                    willClose: function () {
                      that.$router.push({
                        name: "QRCode",
                        params: {},
                      });
                      // 重新整理畫面
                      //location.reload();
                    },
                    allowOutsideClick: false,
                  });
                } else if (res.error_msg) {
                  var error_msg = JSON.parse(res.error_msg);
                  if (res.toekn_error) {
                    that.$swal({
                      heightAuto: false,
                      title: that.$t("錯誤"),
                      text: error_msg[i18n.locale],
                      icon: "error",
                      allowOutsideClick: false,
                      willClose: function () {
                        // 移除登入資訊
                        Storage.remove("ek_login_token");
                        // 回到首頁
                        that.$router.push({
                          name: "Home",
                          params: {},
                        });
                      },
                    });
                  } else {
                    that.$swal({
                      heightAuto: false,
                      title: that.$t("錯誤"),
                      text: error_msg[i18n.locale],
                      icon: "error",
                      allowOutsideClick: false,
                      confirmButtonText: that.$t("確定"),
                    });
                  }
                }
              },
            });
          }
        });
    },
    ticketDonate(TId) {
      let that = this;
      that
        .$swal({
          heightAuto: false,
          title: that.$t("請輸入受贈者手機號碼"),
          html: that.$t("請輸入包含國碼之手機號碼") + "<br />EX: +886912345678",
          input: "text",
          inputAttributes: {
            autocapitalize: "off",
          },
          showCancelButton: true,
          confirmButtonText: that.$t("確定"),
          cancelButtonText: that.$t("取消"),
          showLoaderOnConfirm: true,
          allowOutsideClick: false,
          preConfirm: (phone) => {
            return {
              TId: TId,
              phone: phone,
              token: Storage.get("ek_login_token"),
            };
          },
        })
        .then((result) => {
          if (result.isConfirmed) {
            $.ajax({
              url:
                that.GLOBAL.apiSrc +
                that.GLOBAL.subDirectory +
                "/Htmlv2/TicketDonate",
              type: "post",
              data: {
                TId: result.value.TId,
                phone: result.value.phone,
                token: result.value.token,
              },
              dataType: "json",
              error: function () {
                that.$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  text: that.$t("轉贈票卡過程發生錯誤, 請稍後再試一次"),
                  icon: "error",
                  allowOutsideClick: false,
                  confirmButtonText: that.$t("確定"),
                });
              },
              success: function (res) {
                // 判斷結果
                if (res.ok) {
                  that.$swal({
                    heightAuto: false,
                    icon: "success",
                    title: that.$t("轉贈成功"),
                    text: that.$t(
                      "轉贈碼已透過簡訊傳送至您的手機, 請在24小時內告知受贈者進行驗證, 即可完成轉贈流程"
                    ),
                    confirmButtonText: that.$t("確定"),
                    willClose: function () {
                      // 重新整理畫面
                      location.reload();
                    },
                    allowOutsideClick: false,
                  });
                } else if (res.error_msg) {
                  var error_msg = JSON.parse(res.error_msg);
                  that.$swal({
                    heightAuto: false,
                    title: that.$t("錯誤"),
                    text: error_msg[i18n.locale],
                    icon: "error",
                    allowOutsideClick: false,
                    confirmButtonText: that.$t("確定"),
                  });
                }
              },
            });
          }
        });
    },
    ticketDonateCancel(TId) {
      let that = this;
      $.ajax({
        url:
          that.GLOBAL.apiSrc +
          that.GLOBAL.subDirectory +
          "/Htmlv2/TicketDonateCancel",
        type: "post",
        data: {
          TId: TId,
          token: Storage.get("ek_login_token"),
        },
        dataType: "json",
        error: function () {
          that.$swal({
            heightAuto: false,
            title: that.$t("錯誤"),
            text: that.$t("取消轉贈票卡過程發生錯誤, 請稍後再試一次"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
          });
        },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            that.$swal({
              heightAuto: false,
              icon: "success",
              title: that.$t("取消轉贈成功"),
              text: that.$t("已取消轉贈"),
              confirmButtonText: that.$t("確定"),
              willClose: function () {
                // 重新整理畫面
                location.reload();
              },
              allowOutsideClick: false,
            });
          } else if (res.error_msg) {
            var error_msg = JSON.parse(res.error_msg);
            that.$swal({
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          }
        },
      });
    },
    copyYouBike(text) {
      const texts = text.split("|");
      Storage.set("voucher_uuid", texts[0], "1d");
      Storage.set("voucher_url", texts[1], "1d");
      let that = this;
      this.$copyText(texts[0]).then(
        function (e) {
          that
            .$swal({
              heightAuto: false,
              title: that.$t("複製成功"),
              text: that.$t("是否立刻前往兌換說明頁面進行兌換?"),
              icon: "success",
              allowOutsideClick: false,
              confirmButtonText: that.$t("是"),
              showCancelButton: true,
              cancelButtonText: that.$t("否"),
            })
            .then((result) => {
              if (result.isConfirmed) {
                that.$router.push({
                  name: "Post",
                  params: { PId: 35 },
                });
              }
            });
        },
        function (e) {
          alert(that.$t("序號複製失敗, 請稍後再試一次"));
        }
      );
    },
    // onCopy(e) {
    //   const texts = e.text.split("|");
    //   this.$cookies.set("voucher_uuid", texts[0], "1d");
    //   this.$cookies.set("voucher_url", texts[1], "1d");
    //   this.$swal({
    //     title: this.$t("複製成功"),
    //     text: this.$t("是否立刻前往兌換說明頁面進行兌換?"),
    //     icon: "success",
    //     allowOutsideClick: false,
    //     confirmButtonText: this.$t("是"),
    //     showCancelButton: true,
    //     cancelButtonText: this.$t("否"),
    //   }).then((result) => {
    //     if (result.isConfirmed) {
    //       this.$router.push({
    //         name: "Post",
    //         params: { PId: 35 },
    //       });
    //     }
    //   });
    // },
    // onError(e) {
    //   alert(this.$t("序號複製失敗, 請稍後再試一次"));
    // },
    gotoTicketLog(TId) {
      this.$router.push({
        name: "TicketLog",
        params: { TId: TId },
      });
    },
    refundApplication() {
      let that = this;
      that
        .$swal({
          heightAuto: false,
          title: that.$t("請輸入要退款的票卡數量"),
          html:
            that.$t("此訂單最多可退款票卡數量為: ") +
            that.OrderData.CanRefundAmount,
          input: "number",
          inputValue: 1,
          inputAttributes: {
            autocapitalize: "off",
            min: 1,
            max: that.OrderData.CanRefundAmount,
          },
          inputValidator: (value) => {
            return new Promise((resolve) => {
              if (value < 1) {
                resolve(that.$t("申請退款的票卡數量不可小於1張"));
              } else if (value > that.OrderData.CanRefundAmount) {
                resolve(
                  that.$t("申請退款的票卡數量不可大於") +
                    that.OrderData.CanRefundAmount +
                    that.$t("張")
                );
              } else {
                resolve();
              }
            });
          },
          showCancelButton: true,
          confirmButtonText: that.$t("確定"),
          cancelButtonText: that.$t("取消"),
          showLoaderOnConfirm: true,
          allowOutsideClick: false,
          preConfirm: (amount) => {
            return {
              OrderId: that.OrderData.Order.OrderId,
              amount: amount,
              token: Storage.get("ek_login_token"),
            };
          },
        })
        .then((result) => {
          if (result.isConfirmed) {
            $.ajax({
              url:
                that.GLOBAL.apiSrc +
                that.GLOBAL.subDirectory +
                "/Htmlv2/RefundApplication",
              type: "post",
              data: {
                OrderId: result.value.OrderId,
                amount: result.value.amount,
                token: result.value.token,
              },
              dataType: "json",
              error: function () {
                that.$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  text: that.$t("申請退款過程發生錯誤, 請稍後再試一次"),
                  icon: "error",
                  allowOutsideClick: false,
                  confirmButtonText: that.$t("確定"),
                });
              },
              success: function (res) {
                // 判斷結果
                if (res.ok) {
                  that.$swal({
                    heightAuto: false,
                    icon: "success",
                    title: that.$t("退款申請成功"),
                    text: that.$t("您的退款申請已成功送出"),
                    confirmButtonText: that.$t("確定"),
                    willClose: function () {
                      // 重新整理畫面
                      location.reload();
                    },
                    allowOutsideClick: false,
                  });
                } else if (res.error_msg) {
                  var error_msg = JSON.parse(res.error_msg);
                  that.$swal({
                    heightAuto: false,
                    title: that.$t("錯誤"),
                    text: error_msg[i18n.locale],
                    icon: "error",
                    allowOutsideClick: false,
                    confirmButtonText: that.$t("確定"),
                  });
                }
              },
            });
          }
        });
    },
    refundMApplication() {
      let that = this;
      that
        .$swal({
          heightAuto: false,
          title: "退款",
          html: "申請退款後，將無法使用此票卡，確定進行退款？",
          showCancelButton: true,
          confirmButtonText: that.$t("確定"),
          cancelButtonText: that.$t("取消"),
          showLoaderOnConfirm: true,
          allowOutsideClick: false,
          preConfirm: () => {
            return {
              OrderId: that.OrderData.Order.OrderId,
              token: Storage.get("ek_login_token"),
            };
          },
        })
        .then((result) => {
          if (result.isConfirmed) {
            $.ajax({
              url:
                that.GLOBAL.apiSrc +
                that.GLOBAL.subDirectory +
                "/Htmlv2/RefundMApplication",
              type: "post",
              data: {
                OrderId: result.value.OrderId,
                token: result.value.token,
              },
              dataType: "json",
              error: function () {
                that.$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  text: that.$t("申請退款過程發生錯誤, 請稍後再試一次"),
                  icon: "error",
                  allowOutsideClick: false,
                  confirmButtonText: that.$t("確定"),
                });
              },
              success: function (res) {
                // 判斷結果
                if (res.ok) {
                  that.$swal({
                    heightAuto: false,
                    icon: "success",
                    title: that.$t("退款申請成功"),
                    text: that.$t("您的退款申請已成功送出"),
                    confirmButtonText: that.$t("確定"),
                    willClose: function () {
                      // 重新整理畫面
                      location.reload();
                    },
                    allowOutsideClick: false,
                  });
                } else if (res.error_msg) {
                  var error_msg = JSON.parse(res.error_msg);
                  that.$swal({
                    heightAuto: false,
                    title: that.$t("錯誤"),
                    text: error_msg[i18n.locale],
                    icon: "error",
                    allowOutsideClick: false,
                    confirmButtonText: that.$t("確定"),
                  });
                }
              },
            });
          }
        });
    },
    proveApplication() {
      // 取得訂單及Token
      let tokenProve = AES.encrypt(
        this.OrderData.Order.OrderId + "|" + Storage.get("ek_login_token")
      );
      if (this.isMobile && typeof cordova != "undefined") {
        cordova.InAppBrowser.open(
          this.GLOBAL.apiSrc +
            this.GLOBAL.subDirectory +
            "/Htmlv2/OrderProve?tokenProve=" +
            encodeURIComponent(tokenProve),
          "_system"
        );
      } else {
        window.open(
          this.GLOBAL.apiSrc +
            this.GLOBAL.subDirectory +
            "/Htmlv2/OrderProve?tokenProve=" +
            encodeURIComponent(tokenProve),
          "_blank"
        );
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/OrderInfo.vue